import React from 'react';
import './Sidebar.css';

const Sidebar = ({ currentPage, onNavigate, selectedCategory, onCategorySelect }) => {
  const categories = [
    { value: 'todas', label: 'todo ★', emoji: '✨' },
    { value: 'noticia', label: 'actualidad', emoji: '📰' },
    { value: 'opinión', label: 'opinión', emoji: '💭' },
    { value: 'review-musical', label: 'música', emoji: '🎵' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        {/* Navegación principal */}
        <nav className="sidebar-nav">
          <button
            className={`nav-item ${currentPage === 'feed' ? 'active' : ''}`}
            onClick={() => onNavigate('feed')}
          >
            <span className="nav-emoji">🏠</span>
            <span className="nav-label">home</span>
          </button>

          <button
            className={`nav-item ${currentPage === 'create' ? 'active' : ''}`}
            onClick={() => onNavigate('create')}
          >
            <span className="nav-emoji">✏️</span>
            <span className="nav-label">escribir</span>
          </button>

          <button
            className={`nav-item ${currentPage === 'about' ? 'active' : ''}`}
            onClick={() => onNavigate('about')}
          >
            <span className="nav-emoji">💫</span>
            <span className="nav-label">sobre mí</span>
          </button>
        </nav>

        {/* Separador */}
        <div className="sidebar-separator"></div>

        {/* Filtros de categoría */}
        <div className="sidebar-section">
          <h3 className="section-title">categorías</h3>
          {categories.map((cat) => (
            <button
              key={cat.value}
              className={`category-item ${selectedCategory === cat.value ? 'active' : ''}`}
              onClick={() => onCategorySelect(cat.value)}
            >
              <span className="category-emoji">{cat.emoji}</span>
              <span className="category-label">{cat.label}</span>
            </button>
          ))}
        </div>

        {/* Decoración */}
        <div className="sidebar-decoration">
          <div className="deco-stars">★ ☆ ★</div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;